const Button = ({ className = 'btn btn-primary', children, ...props }) => {
    return(
        <button className={className} {...props}>
            {children}
        </button>
    );
}

export default Button;